module.exports = __webpack_public_path__ + "b4c8b4e6650db34d0111d51a9b614dcc.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/graphics/ecomm-green.png
// module id = 771
// module chunks = 0